import axios from "axios";

// URL relativa: mesmo build em qualquer domínio; cookies ficam same-origin.
const client = axios.create({ baseURL: "/api", withCredentials: true });

let refreshing = null;
client.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing ||= client.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return client(orig);
      } catch {
        if (!window.location.pathname.startsWith("/crm/login")) {
          window.location.href = "/crm/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (detail, fallback = "Algo deu errado. Tente novamente.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};

export const crmLogin = (email, password) => client.post("/auth/login", { email, password });
export const crmMe = () => client.get("/auth/me");
export const crmLogout = () => client.post("/auth/logout");
export const crmForgot = (email) => client.post("/auth/forgot-password", { email });
export const crmReset = (token, password) => client.post("/auth/reset-password", { token, password });
export const crmChangePassword = (current_password, new_password) =>
  client.post("/auth/change-password", { current_password, new_password });
export const crmStats = () => client.get("/crm/stats");
export const crmLeads = (params = {}) => client.get("/crm/leads", { params });
export const crmUpdateLead = (id, body) => client.patch(`/crm/leads/${id}`, body);
export const crmDeleteLead = (id) => client.delete(`/crm/leads/${id}`);
